const FilterSessionStorageKeys = {
  CONNECTOR_FILTERS: 'connector-filters',
  CONNECTOR_SEARCH_BAR: 'search-bar-value-connector-filters',
  CONNECTOR_ORG_UNITS: 'selected-organisation-units-connector-filters',

  DEVICES_FILTERS: 'devices-filters-storage',
  DEVICES_SORTING: 'devices-sorting',
  DEVICES_SEARCH_BAR: 'devices-searchbar',

  SYSTEM_FILTERS: 'system-filters',
  SYSTEM_SEARCH_BAR: 'search-bar-value-system-filters',
  SYSTEM_ORG_UNITS: 'selected-organisation-units-system-filters',

  GATEWAY_FILTERS: 'gateway-filters',
  GATEWAY_SEARCH_BAR: 'search-bar-value-gateway-filters',
  GATEWAY_ORG_UNITS: 'selected-organisation-units-gateway-filters',

  RESIDENT_SETTING_FILTERS: 'resident-setting-filters',
  RESIDENT_SETTING_SEARCH_BAR: 'search-bar-value-resident-setting-filters',
  RESIDENT_SETTING_ORG_UNITS: 'selected-organisation-units-resident-setting-filters',

  RESIDENT_SETTING_CHANGE_LOG_FILTERS: 'resident-setting-change-log-filters',
  RESIDENT_SETTING_CHANGE_LOG_SEARCH_BAR: 'search-bar-value-resident-setting-change-log-filters',
  RESIDENT_SETTING_CHANGE_LOG_ORG_UNITS: 'selected-organisation-units-resident-setting-change-log-filters',
  RESIDENT_SETTING_CHANGE_LOG_DATE_FILTERS: 'resident-setting-change-log-date-filters',
  RESIDENT_SETTING_CHANGE_LOG_SORT: 'residents-change-log-sort',

  TEMPORARY_ACCESS_FILTERS: 'temporary-access-filters',
  TEMPORARY_ACCESS_SEARCH_BAR: 'search-bar-value-temporary-access-filters',
  TEMPORARY_ACCESS_DATE_FILTER: 'temporary-access-date-filter',

  HISTORY_FILTERS: 'history-filters',
  HISTORY_SORTING: 'history-sorting',

  FAULTS_HISTORY_FILTERS: 'faults-history-filters',
  FAULTS_HISTORY_ORG_UNITS: 'selected-organisation-units-faults-history-filters',

  LINKABLE_DEVICES_TABLE_SEARCHBAR: 'linkable-devices-searchbar',
  LINKABLE_DEVICES_FILTERS: 'linkable-devices-filters',
  LINKABLE_DEVICES_SORTING: 'linkable-devices-sorting',
  LINKABLE_TRANSMITTERS_SORTING: 'linkable-transmitters-sorting',
  LINKABLE_TRANSMITTERS_SEARCHBAR: 'linkable-transmitters-searchbar',

  ROLES_SORTING: 'role-sorting',

  TENANTS_SORTING: 'tenants-sorting',

  LINKABLE_WANDERING_BOUNDARIES_SORTING: 'linkable-wandering-boundaries-sorting',
  LINKABLE_WANDERING_BOUNDARIES_SEARCHBAR: 'linkable-wandering-boundaries-searchbar',

  CARE_CONNECT_SETTINGS_EXPANDED_NODES: 'care-connect-settings-expanded-nodes',

  ORGANISATION_TREE_EXPANDED_NODES: 'organisation-tree-expanded-nodes',
  DEVICE_ORGANISATION_PICKER_EXPANDED_NODES: 'device-organisation-picker-expanded-nodes',
  SYSTEM_ORGANISATION_PICKER_EXPANDED_NODES: 'system-organisation-picker-expanded-nodes',
  GATEWAY_ORGANISATION_PICKER_EXPANDED_NODES: 'gateway-organisation-picker-expanded-nodes',

  LINK_ROOM_MODAL_EXPANDED_NODES: 'link-room-modal-expanded-nodes',
};

export default FilterSessionStorageKeys;
